import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/lib/i18n";

export const UpgradeLock = ({ title, desc, testId = "upgrade-lock", label }) => {
  const { L } = useApp();
  return (
    <div className="rounded-2xl border border-violet-200 bg-gradient-to-br from-violet-50 to-white p-6" data-testid={testId}>
      <div className="grid h-10 w-10 place-items-center rounded-xl bg-violet-600 text-white"><Lock size={18} /></div>
      <h3 className="mt-3 font-heading text-lg font-bold">{title}</h3>
      <p className="mt-1 max-w-xl text-sm text-slate-600">{desc}</p>
      <Button asChild className="mt-4 rounded-xl bg-violet-600 hover:bg-violet-700" data-testid={`${testId}-upgrade-btn`}>
        <Link to="/app/billing">{label || L("Naik taraf — mulai RM19.90/bulan", "Upgrade — from RM19.90/month")}</Link>
      </Button>
    </div>
  );
};
